export default {
  headerContent: {
    title: 'Türk Nippon Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta Konut Sigortası',
    description: {
      title: 'Türk Nippon Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Konut sigortası, evinizi ve içerisinde bulunan eşyalarınızı yanma ve hırsızlık gibi birçok risklere karşı koruma altına alır. Konut sigortası risklerin gerçekleşmesi sonucunda oluşacak maddi kayıplara karşı güvence sağlamaktadır. ',
        'Türk Nippon Sigorta konut sigortası ürünü ile evinizde oluşabilecek maddi hasarları güvence altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'Konut sigortası teminatları ana ve ek olmak üzere ayrılmaktadır.',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Dahili Su',
            'Fırtına',
            'Yer Kayması',
            'Kara Ve Hava Taşıtları Çarpması',
            'Duman',
            'Kar Ağırlığı',
            'Grev, Lokavt, Karmaşa Halk Hareketleri, Kötü Niyetli Hareketler Ve Terör',
            'Dahili Dekorasyon',
            'Yangın Mali Sorumluluk Teminatı',
            'Ferdi Kaza',
            '3.Şahıs Mali Mesuliyet',
            'Kira Kaybı',
            'Geçici İkametgâh Değişikliği Masrafları',
            'Enkaz Kaldırma Masrafları',
            'Türk Nippon Asistans Hizmetleri',
            'Hukuksal Koruma',
            'Acil Tıbbi Yardım.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türk Nippon Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
